var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-container',{staticStyle:{"flex-direction":"column"}},[_c('div',{staticStyle:{"color":"#409EFF","margin-top":"20px","font-size":"32px"}},[_vm._v("欢迎访问，汇利弘进销存管理系统")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0efd3c0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/common/pages/dashboard/Dashboard.vue
// module id = null
// module chunks = 